import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, MessageCircle } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { resolveImage } from "../lib/api";
import { buildWhatsAppUrl, openWhatsApp } from "../lib/whatsapp";

const Footer = () => {
  const { content } = useContent();
  const c = content.company || {};
  const navLinks = content.navLinks || [];
  const products = content.products || [];

  return (
    <footer className="bg-[#7f1d1d] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white rounded-md p-2 inline-flex items-center justify-center mb-4">
            <img loading="lazy" decoding="async" src={resolveImage(c.logo)} alt="Aktav Yarka" className="h-14 w-auto object-contain" />
          </div>
          <p className="text-white/65 text-sm leading-relaxed mb-5">Sağlıklı yarka, anahtar teslim kümes kurulumu ve profesyonel veterinerlik hizmetiyle Türkiye'nin güvenilir tavukçuluk firması.</p>
          <div className="flex gap-3">
            {[Facebook, Instagram, Youtube].map((Ic, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-md bg-white/10 hover:bg-white hover:text-[#b91c1c] flex items-center justify-center transition-colors"><Ic className="w-4 h-4" /></a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">Kurumsal</h4>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.href}><a href={l.href} className="text-white/65 hover:text-white text-sm transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">Ürünlerimiz</h4>
          <ul className="space-y-3">
            {products.slice(0, 6).map((p) => (
              <li key={p.id}><a href="#products" className="text-white/65 hover:text-white text-sm transition-colors">{p.name}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">İletişim</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-white/70 shrink-0" />
              <a href={`tel:${(c.phone || "").replace(/\s/g, "")}`} className="text-white/75 hover:text-white">{c.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-white/70 shrink-0" />
              <a href={`mailto:${c.email || ""}`} className="text-white/75 hover:text-white">{c.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-white/70 shrink-0" />
              <span className="text-white/75">{c.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" />
              <a href={buildWhatsAppUrl(c.whatsapp)} onClick={(e) => { e.preventDefault(); openWhatsApp(c.whatsapp); }} target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-white">WhatsApp ile yaz</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/55">
          <span>© 2011 Aktav Yarka. Tüm hakları saklıdır.</span>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Gizlilik Politikası</a>
            <a href="#" className="hover:text-white">KVKK</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
